export const RuleActionQuestion = {
  set_color_green: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: true,
    document_id: true,
    inspection_start_date: true,
    inspection_location: true,
    person: true,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: true,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: true,
    constant: true,
    calculation: true,
    counter: true,
    datetime: true,
    yesno: false,
    switch: false,
    checkbox: false,
    list: false,
    dropdown: false,
    global_list: true,
    signature: false,
    acknowledgment: false,
    photo: false,
    video: false,
    audio: false,
    qr: false,
    barcode: false,
    asset_field: true,
    assignment_field: true
  },
  set_color_red: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: true,
    document_id: true,
    inspection_start_date: true,
    inspection_location: true,
    person: true,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: true,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: true,
    constant: true,
    calculation: true,
    counter: true,
    datetime: true,
    yesno: false,
    switch: false,
    checkbox: false,
    list: false,
    dropdown: false,
    global_list: true,
    signature: false,
    acknowledgment: false,
    photo: false,
    video: false,
    audio: false,
    qr: false,
    barcode: false,
    asset_field: true,
    assignment_field: true
  },
  set_color_yellow: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: true,
    document_id: true,
    inspection_start_date: true,
    inspection_location: true,
    person: true,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: true,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: true,
    constant: true,
    calculation: true,
    counter: true,
    datetime: true,
    yesno: false,
    switch: false,
    checkbox: false,
    list: false,
    dropdown: false,
    global_list: true,
    signature: false,
    acknowledgment: false,
    photo: false,
    video: false,
    audio: false,
    qr: false,
    barcode: false,
    asset_field: true,
    assignment_field: true
  },
  set_color: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: true,
    document_id: true,
    inspection_start_date: true,
    inspection_location: true,
    person: true,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: true,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: true,
    constant: true,
    calculation: true,
    counter: true,
    datetime: true,
    yesno: false,
    switch: false,
    checkbox: false,
    list: false,
    dropdown: false,
    global_list: true,
    signature: false,
    acknowledgment: false,
    photo: false,
    video: false,
    audio: false,
    qr: false,
    barcode: false,
    asset_field: true,
    assignment_field: true
  },
  require_media: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: true,
    document_id: false,
    inspection_start_date: true,
    inspection_location: true,
    person: true,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: true,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: true,
    constant: false,
    calculation: true,
    counter: true,
    datetime: true,
    yesno: true,
    switch: true,
    checkbox: true,
    list: true,
    dropdown: true,
    global_list: true,
    signature: true,
    acknowledgment: true,
    photo: true,
    video: true,
    audio: true,
    qr: true,
    barcode: true,
    asset_field: false,
    assignment_field: false
  },
  require_note: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: true,
    document_id: false,
    inspection_start_date: true,
    inspection_location: true,
    person: true,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: true,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: true,
    constant: false,
    calculation: true,
    counter: true,
    datetime: true,
    yesno: true,
    switch: true,
    checkbox: true,
    list: true,
    dropdown: true,
    global_list: true,
    signature: true,
    acknowledgment: true,
    photo: true,
    video: true,
    audio: true,
    qr: true,
    barcode: true,
    asset_field: false,
    assignment_field: false
  },
  require_action: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: true,
    document_id: true,
    inspection_start_date: true,
    inspection_location: true,
    person: true,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: true,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: true,
    constant: false,
    calculation: true,
    counter: true,
    datetime: true,
    yesno: true,
    switch: true,
    checkbox: true,
    list: true,
    dropdown: true,
    global_list: true,
    signature: true,
    acknowledgment: true,
    photo: true,
    video: true,
    audio: true,
    qr: true,
    barcode: true,
    asset_field: false,
    assignment_field: false
  },
  set_value: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: false,
    document_id: false,
    inspection_start_date: false,
    inspection_location: false,
    person: false,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: false,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: true,
    constant: false,
    calculation: false,
    counter: false,
    datetime: false,
    yesno: true,
    switch: true,
    checkbox: false,
    list: true,
    dropdown: true,
    global_list: false,
    signature: false,
    acknowledgment: false,
    photo: false,
    video: false,
    audio: false,
    qr: false,
    barcode: false,
    asset_field: false,
    assignment_field: false
  },
  set_value_not_answered: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: false,
    document_id: false,
    inspection_start_date: false,
    inspection_location: false,
    person: false,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: false,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: true,
    constant: false,
    calculation: false,
    counter: false,
    datetime: false,
    yesno: true,
    switch: true,
    checkbox: false,
    list: true,
    dropdown: true,
    global_list: false,
    signature: false,
    acknowledgment: false,
    photo: false,
    video: false,
    audio: false,
    qr: false,
    barcode: false,
    asset_field: false,
    assignment_field: false
  },
  set_score: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: false,
    document_id: false,
    inspection_start_date: false,
    inspection_location: false,
    person: false,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: true,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: true,
    constant: false,
    calculation: true,
    counter: true,
    datetime: true,
    yesno: false,
    switch: false,
    checkbox: false,
    list: false,
    dropdown: false,
    global_list: false,
    signature: false,
    acknowledgment: true,
    photo: false,
    video: false,
    audio: false,
    qr: false,
    barcode: false,
    asset_field: false,
    assignment_field: false
  },
  set_rating: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: false,
    document_id: false,
    inspection_start_date: true,
    inspection_location: false,
    person: false,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: true,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: true,
    constant: false,
    calculation: true,
    counter: true,
    datetime: true,
    yesno: false,
    switch: false,
    checkbox: true,
    list: false,
    dropdown: false,
    global_list: false,
    signature: false,
    acknowledgment: true,
    photo: false,
    video: false,
    audio: false,
    qr: false,
    barcode: false,
    asset_field: false,
    assignment_field: false
  },
  disable_else_enable: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: false,
    document_id: true,
    inspection_start_date: false,
    inspection_location: false,
    person: false,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: false,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: false,
    constant: false,
    calculation: false,
    counter: false,
    datetime: false,
    yesno: true,
    switch: true,
    checkbox: false,
    list: true,
    dropdown: true,
    global_list: false,
    signature: false,
    acknowledgment: false,
    photo: false,
    video: false,
    audio: false,
    qr: false,
    barcode: false,
    asset_field: false,
    assignment_field: false
  },
  disable: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: false,
    document_id: true,
    inspection_start_date: false,
    inspection_location: false,
    person: false,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: false,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: false,
    constant: false,
    calculation: false,
    counter: false,
    datetime: false,
    yesno: true,
    switch: true,
    checkbox: false,
    list: true,
    dropdown: true,
    global_list: false,
    signature: false,
    acknowledgment: false,
    photo: false,
    video: false,
    audio: false,
    qr: false,
    barcode: false,
    asset_field: false,
    assignment_field: false
  },
  enable_else_disable: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: false,
    document_id: true,
    inspection_start_date: false,
    inspection_location: false,
    person: false,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: false,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: false,
    constant: false,
    calculation: false,
    counter: false,
    datetime: false,
    yesno: true,
    switch: true,
    checkbox: false,
    list: true,
    dropdown: true,
    global_list: false,
    signature: false,
    acknowledgment: false,
    photo: false,
    video: false,
    audio: false,
    qr: false,
    barcode: false,
    asset_field: false,
    assignment_field: false
  },
  enable: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: false,
    document_id: true,
    inspection_start_date: false,
    inspection_location: false,
    person: false,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: false,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: false,
    constant: false,
    calculation: false,
    counter: false,
    datetime: false,
    yesno: true,
    switch: true,
    checkbox: false,
    list: true,
    dropdown: true,
    global_list: false,
    signature: false,
    acknowledgment: false,
    photo: false,
    video: false,
    audio: false,
    qr: false,
    barcode: false,
    asset_field: false,
    assignment_field: false
  },
  required_else_not_required: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: true,
    document_id: true,
    inspection_start_date: false,
    inspection_location: false,
    person: false,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: false,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: true,
    constant: false,
    calculation: false,
    counter: false,
    datetime: true,
    yesno: true,
    switch: true,
    checkbox: false,
    list: true,
    dropdown: true,
    global_list: true,
    signature: true,
    acknowledgment: true,
    photo: true,
    video: true,
    audio: true,
    qr: true,
    barcode: true,
    asset_field: false,
    assignment_field: false
  },
  set_hidden: {
    page: true,
    start_page: true,
    end_page: true,
    hidden_page: false,
    section: true,
    asset: true,
    document_id: true,
    inspection_start_date: true,
    inspection_location: false,
    person: true,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: true,
    textAnswer: true,
    longText: true,
    instruction: true,
    number: true,
    slider: true,
    constant: true,
    calculation: true,
    counter: false,
    datetime: true,
    yesno: true,
    switch: true,
    checkbox: true,
    list: true,
    dropdown: true,
    global_list: false,
    signature: false,
    acknowledgment: false,
    photo: true,
    video: false,
    audio: false,
    qr: false,
    barcode: false,
    asset_field: true,
    assignment_field: true,
    global_page: true,
    global_section: true,
    global_item: true,
    global_items: true
  },
  required: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: true,
    document_id: true,
    inspection_start_date: false,
    inspection_location: false,
    person: false,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: false,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: true,
    constant: false,
    calculation: false,
    counter: false,
    datetime: true,
    yesno: true,
    switch: true,
    checkbox: false,
    list: true,
    dropdown: true,
    global_list: true,
    signature: true,
    acknowledgment: true,
    photo: true,
    video: true,
    audio: true,
    qr: true,
    barcode: true,
    asset_field: false,
    assignment_field: false
  },
  not_required: {
    page: false,
    start_page: false,
    end_page: false,
    hidden_page: false,
    section: false,
    asset: true,
    document_id: true,
    inspection_start_date: false,
    inspection_location: false,
    person: false,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: false,
    textAnswer: true,
    longText: true,
    instruction: false,
    number: true,
    slider: true,
    constant: false,
    calculation: false,
    counter: false,
    datetime: true,
    yesno: true,
    switch: true,
    checkbox: false,
    list: true,
    dropdown: true,
    global_list: true,
    signature: true,
    acknowledgment: true,
    photo: true,
    video: true,
    audio: true,
    qr: true,
    barcode: true,
    asset_field: false,
    assignment_field: false
  },
  exclude_report: {
    page: true,
    start_page: true,
    end_page: true,
    hidden_page: false,
    section: true,
    asset: true,
    document_id: true,
    inspection_start_date: true,
    inspection_location: true,
    person: true,
    inspection_real_start_date: false,
    inspection_real_end_date: false,
    inspection_end_date: true,
    textAnswer: true,
    longText: true,
    instruction: true,
    number: true,
    slider: true,
    constant: true,
    calculation: true,
    counter: true,
    datetime: true,
    yesno: true,
    switch: true,
    checkbox: true,
    list: true,
    dropdown: true,
    global_list: true,
    signature: true,
    acknowledgment: true,
    photo: true,
    video: true,
    audio: true,
    qr: true,
    barcode: true,
    asset_field: true,
    assignment_field: true,
    global_page: true,
    global_section: true,
    global_item: true,
    global_items: true
  }
}
